export default "__VITE_ASSET__12d024e7__"